<template>
  <div class="board relative">
    <Grid :artwork="artwork" :height="height" :cellSize="cellSize" :grid="grid" :isInLine="isInLine" ref="grid"></Grid>
    <Artwork v-if="artwork" v-bind="artwork" :height="height" />
  </div>
</template>

<script>
import Grid from "./Grid";
import Artwork from "./Artwork";

export default {
  data: function() {
    return {
      artwork: null,
      selectedWords: []
    };
  },
  methods: {},
  inject: ["getFirstImage"],
  mounted: function() {
    console.log('board, isInLine =', this.isInLine);
    this.$root.$on("image:show", (current, update) => {
      // eslint-disable-next-line
      if (!update) {
        return;
      }
      if (current) {
        this.artwork = current;
        this.$root.$emit("setcurrentimage", this.artwork);
      } else if (this.$parent.grid.images[0]) {
        this.artwork = this.$parent.grid.images[0];
        this.$root.$emit("setcurrentimage", this.artwork);
      } else {
        this.artwork = this.getFirstImage;
        this.$root.$emit("setcurrentimage", this.artwork);
      }
    });
    this.$root.$on("image:hide", () => {
      this.artwork = null;
    });
    this.$root.$on("cell:selected", () => {
      this.selectedWords = [];
    });
    this.$root.$on("image:placed", () => {
      this.selectedWords = [];
    });
    this.$root.$on("word:selected", word => {
      setTimeout(() => {
        this.selectedWords.push(word);
      }, 100);
    });

    // this.cellSize = this.$el.getBoundingClientRect().width / this.grid.rows;
  },
  props: {
    grid: Object,
    isInLine: Boolean,
  },
  components: {
    Grid,
    Artwork
  },
  computed: {
    words: function() {
      return [...new Set(this.selectedWords)];
    },
    cellSize: {
      get: function() {
        if (window.innerWidth > 1000) {
          return 100;
        }
        return 280 / this.grid.rows;
      },
      set: function(size) {
        return size;
      }
    },
    height: function() {
      return -2 + this.grid.rows * (this.cellSize + 2);
    },
    width: function() {
      return -2 + this.grid.cols * (this.cellSize + 2);
    }
  }
};
</script>

<style scoped>
.board-container {
  background: coral;
  flex: 1;
  display: flex;
  align-items: center;
  height:100%;
  width:100%;
}

.wrapper {
  flex: 1;
}

.tooltip-word-1 {
  background: #f9ab00;
}

.tooltip-word-2 {
  background: #9334e6;
}

.tooltip-word-3 {
  background: #12b5cb;
}

.tooltip-word-4 {
  background: #e8710a;
}

.tooltip-word-5 {
  background: #e52592;
}

.tooltip-word-6 {
  background: #d93025;
}

.board {
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-shrink: 0;
  align-items: stretch;
  font-size: 1rem;
  flex: 1;
  display: flex;
  justify-content: stretch;
  width: 100%;
  height: calc(100% - 188px);
}
/* 
@media screen and (min-width: 1000px) {
  .board {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    padding: 0;
    align-items: center;
  }
} */


@media screen and (max-width: 1000px) {
  /* .board {
    flex-direction: row;
    justify-content: flex-start;
  } */

  .tooltip-word {
    margin: 0;
    padding: 0.2rem 0.5rem;
    height: 24px;
  }

  .tooltip-word + .tooltip-word {
    margin-left: 1rem;
  }

  .tooltip-word span {
    display: inline-block;
    vertical-align: top;
    line-height: 24px;
  }
}

.game,
.artwork {
  height: 80%;
  margin: 0;
  flex: 1;
  justify-content: center;
}

.artwork {
  height:100%;
}


.game {
  background: white;
  height:100%;
  overflow:scroll;
}


.actions {
  position: absolute;
  right: 0.6rem;
  bottom: 0.6rem;
  z-index: 9;
}

.backtomenu {
  display: flex;
  font-size: 25px;
  padding: 10px;
  margin: 0;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
  cursor: pointer;
}

@media (orientation: landscape) and (hover: none) and (pointer: coarse) {
  .board{
    height:calc(100% - 128px);
  }
}
</style>
